import { render, staticRenderFns } from "./CoordPage.vue?vue&type=template&id=2466521a&"
import script from "./CoordPage.vue?vue&type=script&lang=js&"
export * from "./CoordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports